import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(
  (theme, responsive, safeAreaInsets) => ({
    root: {
      flex: 1,
      paddingTop: safeAreaInsets.top,
      width: 'auto',
      backgroundColor: theme.colors.background,
    },
    scrollContainer: {
      flex: 1,
    },
    contentContainer: {
      flexGrow: 1,
    },
    item: {
      height: spacing.xxl,
      paddingHorizontal: spacing.s,
      flexDirection: 'row',
      alignItems: 'center',
    },
    iconWrapper: {
      width: spacing.l,
      maxWidth: spacing.l,
      marginRight: spacing.xs,
    },
    externalLinkIcons: {
      flexDirection: 'row',
      marginLeft: spacing.xs,
      gap: spacing.xs,
      paddingVertical: spacing.xs,
    },
    newLabel: {
      backgroundColor: theme.colors.backgroundDark,
      paddingVertical: spacing.xxs,
      paddingHorizontal: spacing.xs,
      borderRadius: theme.box.borderRadius,
    },
  }),
);
